var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"lg":"7"}},[_c('StudentMappingTable')],1),_c('CCol',{attrs:{"lg":"5"}},[_c('AddStudent')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }